import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IPopup } from "../models/Popup";

const initialState: IPopup = {
  content: null,
  open: false,
};

const popupSlice = createSlice({
  name: "popup",
  initialState,
  reducers: {
    setContent(state, action: PayloadAction<React.ReactNode>) {
      state.content = action.payload;
    },

    setOpen(state, action: PayloadAction<boolean>) {
      state.open = action.payload;
    },
  },
});

export const { setContent, setOpen } = popupSlice.actions;

export default popupSlice.reducer;
